module.exports = __webpack_public_path__ + "static/logo-white-8440d75d55e40d3796152ee6e5b33123.svg";